<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    labels: {
      type: Array,
      default: null
    },
    colors: {
      type: Array,
      default: null
    },
    data: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      chartdata: {
        labels: this.labels,
        datasets: [
          {
            data: this.data,
            borderColor: this.colors,
            fill: false,
            lineTension: 0,
            pointRadius: 10,
            pointHoverRadius: 15
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function(tick) {
                  return tick.toString() + "%";
                }
              }
            }
          ]
        },
        tooltips: {
          custom: function(tooltip) {
            // Disable displaying the color box
            if (!tooltip) return;
            tooltip.displayColors = false;
          },
          callbacks: {
            // Show percentage in tooltip
            label: function(tooltipItem, data) {
              return data["datasets"][0]["data"][tooltipItem["index"]] + "%";
            }
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  }
};
</script>
